import React, { useEffect } from 'react';
import { Grid, Box, Container, Typography } from '@mui/material';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import AboutSection from '../../components/HomeSections/AboutSection/AboutSection';
import MapSection from '../../components/MapSection/MapSection';
import { useLanguage } from '../../context/LanguageContext/LanguageContext';
import FeatureCard from '../../components/services/FeatureCard/FeatureCard';
import gallery1 from './../../assets/images/service/gallery1.png'
import gallery2 from './../../assets/images/service/gallery2.png'
import Gallery from "../../components/services/Gallery/Gallery";
import FeatureGrid from '../../components/services/FeatureGrid/FeatureGrid';
const AboutUs = () => {
    const { translations, direction, language } = useLanguage();
    const t = translations;

    const mapContainerStyle = {
        height: '400px',
        width: '100%',
        borderRadius: '8px',
        marginTop: '30px',
    };

    const center = {
        lat: 40.748817,
        lng: -73.985428,
    };

    const markerPosition = {
        lat: 40.748817, // Replace with the latitude of your location
        lng: -73.985428, // Replace with the longitude of your location
    };

    return (
        <Box sx={{ backgroundColor: "#FAFAFA" }}>
            <AboutSection data-aos="fade-up" t={t} direction={direction} language={language} />
            {/* Features Section */}
            <FeatureGrid language={language} t={t} />
            {/* Map Section */}
            <Box maxWidth="100%" sx={{ mt: 2 }}>
                <Typography
                    variant="h4"
                    component="h2"
                    sx={{ color: "var(--primary-color)", fontWeight: 'bold', textAlign: 'center', marginBottom: 2 }}
                >
                    {t.ourLocation}
                </Typography>
                <MapSection />
            </Box>
        </Box>
    );
};

export default AboutUs;
